"use client";

import { useTheme } from "@/contexts/theme-context";

export default function ThemeWrapper({ children }: { children: React.ReactNode }) {
    const { theme } = useTheme();

    return (
        <div className={`contents ${theme.font.class}`}>
            {children}
        </div>
    );
}
